<template>
  <div class="body">
    <van-nav-bar title="订单详情" left-text left-arrow @click-left="onClickLeft" class="topNav"/>
    <div class="content">
      <p class="OrderState">{{data.state_text}}</p>
      <DetailOrder :data="data" :hasfinish="data.state==3 ? true : false"/>
    </div>
    <div v-if="data.state==0" class="ListBtnWrap">
      <button class="ListBtn ListBtnCancel" @click="cencel(data.oid,'是否取消订单?')">取消</button>
      <button class="ListBtn ListBtnPay" @click="buy(data.oid)">付款</button>
    </div>
    <div v-if="data.state==1" class="ListBtnWrap">
      <button class="ListBtn ListBtnCancel listF" @click="cencel(data.oid,'是否申请取消订单?')">申请取消</button>
    </div>
    <div v-if="data.state==2" class="ListBtnWrap">
      <button class="ListBtn listBtnFinish" @click="finish(data.oid)">确认收货</button>
    </div>
  </div>
</template>

<script>
import DetailOrder from "@/components/DetailOrder.vue";
import {
  OrderDetail,
  cencelOrder,
  OrderBuy,
  finishOrder
} from "../../apis/https.js";
import { getSessionStorage, getLocalStorage } from "../../utils/storage.js";
import { Dialog } from "vant";
import { stat } from 'fs';
// import { Checkbox, CheckboxGroup } from "vant";
// import Vue from "vue";
// Vue.use(Checkbox).use(CheckboxGroup);
export default {
  components: {
    DetailOrder
  },
  data() {
    return {
      data: {
        id: "",
        create_time: "",
        address: {
          name: "",
          phone: "",
          city: "",
          province: "",
          region: ""
        },
        express:{
          name:"",
          num:""
        },
        hasexpress:false,
        goods: [],
        total_price: "",
        total_num: "",
        coupon_price: "",
        express_price: "",
        pay_price: "",
        state_text: "",
        state: -1
      }
    };
  },
  created() {},
  activated() {
    let id = this.$route.query.id;
    this.$toast.clear();
    this.$toast.loading({
      duration: 0, // 持续展示 toast
      forbidClick: true, // 禁用背景点击
      loadingType: "spinner",
      message: "加载中"
    });
    OrderDetail(id, getLocalStorage("login_token"))
      .then(res => {
        //   this.data
        this.$toast.clear();
        let data = res.data.order;
        this.data.oid = data.order_id;
        this.data.id = data.order_no;
        this.data.create_time = data.create_time;
        this.data.state_text = data.state_text;
        this.data.address.name = data.address.name;
        this.data.address.phone = data.address.phone;
        this.data.address.city = data.address.region.city;
        this.data.address.province = data.address.region.province;
        this.data.address.region = data.address.region.region;
        this.data.total_price = data.total_price;
        this.data.coupon_price = data.coupon_price;
        this.data.total_num = data.order_total_num;
        this.data.pay_price = data.pay_price;
        this.data.express_price = data.express_price;
        this.data.goods = [];
        let state = -1;
        if (data.pay_time === 0 && data.state_text != "已取消") {
          //待付款
          state = 0;
        } else if (
          data.pay_time > 0 &&
          data.delivery_time == 0 &&
          data.state_text != "已取消"
        ) {
          //待发货
          state = 1;
        } else if (
          data.delivery_time > 0 &&
          data.receipt_time == 0 &&
          data.state_text != "已取消"
        ) {
          //待收货
          state = 2;
        } else if (data.receipt_time > 0 && data.state_text != "已取消") {
          //完成
          state = 3;
        }
        this.data.state = state;
        if(data.delivery_type.value=='10'&&stat>=2){
          this.data.hasexpress=true;
          this.data.express.name=data.express.express_name;
          this.data.express.num=data.express_no;
        }
        for (let i in data.goods) {
          let refund=false;
          if(data.goods[i].refund==null&&this.data.state>=3){
            refund=true;
          }
          this.data.goods.push({
            id: data.goods[i].goods_id,
            oid:data.goods[i].order_goods_id,
            name: data.goods[i].goods_name,
            skuid: data.goods[i].goods_sku_id,
            img: data.goods[i].image.file_path,
            num: data.goods[i].total_num,
            pirce: data.goods[i].total_price,
            refund:refund
          });
          console.log(this.data.goods)
        }
      })
      .catch(e => {});
  },
  methods: {
    onClickLeft() {
      let fo = this.$route.query.fo || false;
      if(fo){
        this.$router.push('/home');
      }else{
        this.$router.go(-1);
      }
    },
    cencel(id,msg) {
      Dialog.confirm({
        title: "提示",
        message: msg
      })
        .then(() => {
          // on confirm
          this.$toast.loading({
            duration: 0, // 持续展示 toast
            forbidClick: true, // 禁用背景点击
            loadingType: "spinner",
            message: "加载中"
          });
          cencelOrder(id, getLocalStorage("login_token"))
            .then(res => {
              this.$toast.clear();
              Dialog.alert({
                title: "提示",
                message: "订单删除成功"
              }).then(() => {
                // on close
                this.$router.push("/pages/order/index");
              });
            })
            .catch(e => {
              this.$toast.clear();
              if(res.msg=="请先选择收货地址"){
                this.$toast.fail("请先选择收货地址");
              }else{
                this.$toast.fail("支付失败");
              } 
            });
        })
        .catch(() => {
          // on cancel
        });
    },
    buy(id) {
      this.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        loadingType: "spinner",
        message: "加载中"
      });
      OrderBuy(id, "url", getLocalStorage("login_token")).then(res => {
        location.href = res.data.ali_pay_url;
      });
    },
    finish(id) {
      Dialog.confirm({
        title: "提示",
        message: "是否确认收货?"
      })
        .then(() => {
          // on confirm
          this.$toast.loading({
            duration: 0, // 持续展示 toast
            forbidClick: true, // 禁用背景点击
            loadingType: "spinner",
            message: "加载中"
          });
          finishOrder(id, getLocalStorage("login_token")).then(res => {
            this.$toast.clear();
            Dialog.alert({
              title: "提示",
              message: "订单已完成"
            }).then(() => {
              // on close
              this.$router.go(0);
            });
          });
        })
        .catch(() => {
          // on cancel
        });
    }
  }
};
</script>
<style lang="less" scoped>
@import url("../../style/skin.less");
.OrderState {
  height: 80px;
  font-size: 16px;
  line-height: 80px;
  padding: 0px 20px;
  background: url("../../assets/frame-img/refund-bg.jpg");
  color: @white;
}
.body {
  background: #f4f8fb;
  min-height: 100vh;
  overflow: hidden;
  .topNav {
    position: fixed;
    width: 100%;
    top: 0px;
    i {
      color: #323233 !important;
    }
  }
  .content {
    margin-top: 46px;
    margin-bottom: 50px;
  }
  .ListBtnWrap {
    position: fixed;
    bottom: 0;
    width: 100%;
    overflow: hidden;
    background: @white;
    .ListBtn {
      float: left;
      width: 50%;
      border: 0px;
      height: 50px;
      font-size: 14px;
    }
    .ListBtnCancel {
      background: @white;
    }
    .ListBtnPay {
      background: @text;
      color: @white;
    }
    .listF {
      float: right;
    }
    .listBtnFinish {
      width: 100%;
      background: @text;
      color: @white;
    }
  }
}
</style>